import { Logger } from '@amplement/backend-connector';

export default Logger;
